import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import Login from "./pages/Login";
import DashboardLayout from "./layouts/DashboardLayout";
import ManageUsers from "./pages/ManageUsers";
import FeedbackList from "./pages/FeedbackList";
import ExpertUsersList from "./pages/ExpertUsersList";
import AuthLayout from "./layouts/AuthLayout";
import Profile from "./pages/Profile";
import RecycleBin from "./pages/RecycleBin";
import { ToastContainer } from "react-toastify";
import { useAuth } from "./context/AuthContext";
import WithdrawalRequests from "./pages/WithdrawalRequests";
import Reports from "./pages/Reports";
import CallHistory from "./pages/CallHistroy";

function App() {
  const { isLogin } = useAuth();

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-center"
        stacked={true}
        hideProgressBar={true}
        autoClose={3000}
        style={{ zIndex: 11111111100000000 }}
      />

      {!isLogin ? (
        <Routes>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Login />} />
          </Route>
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route path="/" element={<ManageUsers />} />
            <Route path="/users" element={<ManageUsers />} />
            <Route path="/users/experts" element={<ExpertUsersList />} />
            <Route path="/feedbacks" element={<FeedbackList />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/recycle" element={<RecycleBin />} />
            <Route path="/withdrawal-requests" element={<WithdrawalRequests />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/call-history" element={<CallHistory />} />
          </Route>
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
